// Note: this definition must stay in lockstep with EatingHabit in funnel/src/defs/quiz.ts
export enum EatingHabit {
  Omnivore = 'omnivore',
  Flexitarian = 'flexitarian',
  Pescatarian = 'pescatarian',
  Vegetarian = 'vegetarian',
  Vegan = 'vegan',
}
